import getters from './../Getters/userData.js';
import actions from './../Actions/userData.js';
import mutations from './../Mutations/userData.js';

export default {
    namespaced: true,

    state: {
        loggedIn: false,
        language: navigator.browserLanguage || navigator.language || 'de',
        data: {}
    },

    getters,
    actions,
    mutations
};
